import { render } from "./CalloutSection.vue?vue&type=template&id=a5c88860"
import script from "./CalloutSection.vue?vue&type=script&lang=js"
export * from "./CalloutSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__